<template>
  <b-navbar toggleable="lg" fixed="top">

    <div class="container">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <a :href="homepageUrl">
          <img class="header__logo-image" src="~assets/img/logo-header.png">
        </a>
        <a href="http://www.ttalliance.com/">
          <img class="header__logo-image header__logo-image--brand" src="~assets/img/logo-transformation-alliance.jpg">
        </a>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-b-modal.modalPurpose>Purpose</b-nav-item>
          <b-nav-item v-b-modal.modalNetwork>Ecosystems</b-nav-item>
          <b-nav-item v-b-modal.modalDynamism>Adaptability</b-nav-item>
          <b-nav-item v-b-modal.modalEmpowerment>Real Empowerment</b-nav-item>
          <b-nav-item v-b-modal.modalLeadership>Leadership</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </div>

    <b-modal ref="modalPurpose" id="modalPurpose" centered hide-footer hide-header>
      <purpose-info>
        <button @click="hideModal" class="custom-btn custom-btn--green">BACK</button>
      </purpose-info>
    </b-modal>

    <b-modal ref="modalDynamism" id="modalDynamism" centered hide-footer hide-header>
      <adaptability-info>
        <button @click="hideModal" class="custom-btn custom-btn--green">BACK</button>
      </adaptability-info>
    </b-modal>

    <b-modal ref="modalNetwork" id="modalNetwork" centered hide-footer hide-header>
      <ecosystem-info>
        <button @click="hideModal" class="custom-btn custom-btn--green">BACK</button>
      </ecosystem-info>
    </b-modal>

    <b-modal ref="modalEmpowerment" id="modalEmpowerment" centered hide-footer hide-header>
      <empowerment-info>
        <button @click="hideModal" class="custom-btn custom-btn--green">BACK</button>
      </empowerment-info>
    </b-modal>

    <b-modal ref="modalLeadership" id="modalLeadership" centered hide-footer hide-header>
      <leadership-info>
        <button @click="hideModal" class="custom-btn custom-btn--green">BACK</button>
      </leadership-info>
    </b-modal>

  </b-navbar>
</template>

<script>
import PurposeInfo from '@/components/Evaluation/Purpose/Info';
import AdaptabilityInfo from '@/components/Evaluation/Dynamism/Info';
import EcosystemInfo from '@/components/Evaluation/Network/Info';
import EmpowermentInfo from '@/components/Evaluation/Empowerment/Info';
import LeadershipInfo from '@/components/Evaluation/Leadership/Info';

export default {
  components: { PurposeInfo, AdaptabilityInfo, EcosystemInfo, EmpowermentInfo, LeadershipInfo },
  data() {
    return {
      homepageUrl: process.env.HOMEPAGE,
    };
  },
  methods: {
    hideModal() {
      this.$refs.modalPurpose.hide();
      this.$refs.modalDynamism.hide();
      this.$refs.modalEmpowerment.hide();
      this.$refs.modalNetwork.hide();
      this.$refs.modalLeadership.hide();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Navbar/Evaluation.vue